import EnquiryList, { EnquiryItemType, State as EnquiryItemState, LiveAgentCacheVariable } from '@/components/EnquiryList';
import React from 'react';
import show from '../Drawer/show';

export default function waitEnquirySelect(dataSource: EnquiryItemType[], initState?: EnquiryItemState, liveAgentCacheVar?: LiveAgentCacheVariable,
): Promise<{userType?: EnquiryItemType, enquiryType?: EnquiryItemType, enquiryItemState?: EnquiryItemState, isAutoSelect?: boolean, isClose?: boolean}> {
  // 没有配置任何 user type 和 enquiry type 数据
  if (dataSource.length === 0) {
    return Promise.resolve({
      userType: { value: undefined, content: '' },
      enquiryType: { value: undefined, content: '' },
    });
  }

  // 以下两种情况不唤起选择窗：1.都只有一个可选项默认选中；2.只配置了 user type 而没有配置 enquiry type
  if (dataSource.length === 1 && (dataSource[0].child && dataSource[0].child.length <= 1)) {
    const { value, content, child = [] } = dataSource[0];
    return Promise.resolve({ userType: { value, content }, enquiryType: { ...child[0] }, isAutoSelect: true });
  }

  const changedSelect = { userType: undefined, enquiryType: undefined } as any;

  return new Promise((resolve) => {
    const instance = show({
      height: 'initial',
      children: (
        <EnquiryList
          onClose={() => {
            instance.destroy();
          }}
          onSubmit={([userType, enquiryType], enquiryItemState) => {
            resolve({ userType, enquiryType, enquiryItemState });
          }}
          onChange={({ userType, enquiryType }) => {
            changedSelect.userType = userType;
            changedSelect.enquiryType = enquiryType;
          }}
          initState={initState}
          dataSource={dataSource}
          liveAgentCacheVar={liveAgentCacheVar}
        />
      ),
      onClose: () => {
        resolve({ ...changedSelect, isClose: true });
        instance.destroy();
      },
    });
  });
}
